import { render, staticRenderFns } from "./cly-tabs.vue?vue&type=template&id=29a3c1b6"
import script from "./cly-tabs.vue?vue&type=script&lang=js"
export * from "./cly-tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports